import "../App.css";
import Hero from "../components/HeroSection";
import Features from "../components/FeatureSection";
import Stats from "../components/Stats";

function App() {
  return (
    <>
      <Hero />
      <Features />
      <Stats />
    </>
  );
}

export default App;
